// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"e0f45836","179":"7c380e05","243":"8fe26ca9","272":"28d03084","630":"1535e8a8","725":"daadf550","825":"62fd4776"}[chunkId] + ".chunk.js";
};